import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UnassignProductSeatResultModal} from './unassign-product-seat.result.modal';
import {
    clearResult,
    selectUnassignProductSeatShown,
    selectUnassignProductSeatTask,
    selectUnassignProductSeatUuid,
} from './unassign-product-seat.slice';

export const UnassignProductSeatResult = () => (
    <BulkActionResult
        actionIdSelector={selectUnassignProductSeatUuid}
        actionTaskSelector={selectUnassignProductSeatTask}
        actionShownSelector={selectUnassignProductSeatShown}
        clearResult={clearResult}>
        {({id, onClose}) => <UnassignProductSeatResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
